const JPEG_DATA_URI_PREFIX = "data:image/jpeg;base64,";

/** Turns the raw base64 JPEG thumbnail sent by the API into an image source, or undefined when there is none. */
export const toThumbnailSrc = (thumbnail?: string | null): string | undefined => {
	if (!thumbnail) {
		return undefined;
	}

	if (thumbnail.startsWith("data:")) {
		return thumbnail;
	}

	return `${JPEG_DATA_URI_PREFIX}${thumbnail}`;
};
